import { render, staticRenderFns } from "./CButtons.vue?vue&type=template&id=7d8645bd&scoped=true"
import script from "./CButtons.vue?vue&type=script&lang=js"
export * from "./CButtons.vue?vue&type=script&lang=js"
import style0 from "./CButtons.vue?vue&type=style&index=0&id=7d8645bd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d8645bd",
  null
  
)

export default component.exports